import { useMemo } from "react";

const useTotalPages = (totalCount: number, rowsPerPage: number = 20) => {
  const totalPages = useMemo(() => {
    return Math.floor(
      totalCount / rowsPerPage + (totalCount % rowsPerPage === 0 ? 0 : 1)
    );
  }, [rowsPerPage, totalCount]);

  return totalPages;
};

export default useTotalPages;
